export type ConciliationReportViewType = "lack" | "status-grid";

export const VIEW_TYPES = [
  { value: "lack" as const, label: "Falta de Conciliação" },
  { value: "status-grid" as const, label: "Grade de Status" },
] as const;

export interface DateRangeType {
  from: Date;
  to: Date;
}

export interface StatusOptionType {
  value: string;
  label: string;
  abbr: string;
  color: string;
}

export const STATUS_OPTIONS: StatusOptionType[] = [
  { value: "OPENED", label: "Aberta", abbr: "AB", color: "#ef4444" },
  { value: "PENDING", label: "Aguardando", abbr: "AG", color: "#E3B400" },
  { value: "CLOSED", label: "Fechada", abbr: "OK", color: "#00AC4F" },
  { value: "NOT_INTEGRATED", label: "Não Integrada", abbr: "-", color: "#9ca3af" },
];
